import { ConfigData } from "@configs/config-data.type";

export const sacylEXCfg: ConfigData = {
	apiUrl: 'https://fescyl-api-core.saludcastillayleon.es',
	title: 'Core',
	logos: {
		login: 'assets/images/logos/sacyl/logo-text-white-v2.png',
		menu: 'assets/images/logos/sacyl/logo-text-white.png',
	},
};
